export const en = {
  sidebar: {
    sections: {
      myWork: "My Work",
      teamInbox: "Team Inbox",
      byTrigger: "By Trigger",
      management: "Management",
      settings: "Settings",
    },
    items: {
      myDay: "My Day",
      mySnoozed: "My Snoozed",
      myArchived: "My Archived",
      unassigned: "Unassigned",
      needsAttention: "Needs Attention",
      confirmationNeeded: "Confirmation Needed",
      openDraftOrders: "Open Draft Orders",
      checkoutRecovery: "Checkout Recovery",
      customers: "Customers",
      reports: "Reports",
      storeConnection: "Store Connection",
      triggerRules: "Rules",
      usersTeams: "Users & Teams",
      syncHealth: "Sync Health",
      preferences: "Preferences",
      billing: "Billing",
    },
  },
  topbar: {
    profileSettings: "Profile Settings",
    logout: "Logout",
    logoutConfirmTitle: "Logout",
    logoutConfirmDescription: "Are you sure you want to logout?",
    logoutFailed: "Logout failed. Please try again.",
    logoutConfirm: "Yes",
    loggingOut: "Logging out...",
  },
  gettingStarted: {
    label: "Getting started",
    allDone: "All done!",
  },
  localeSelector: {
    language: "Language",
  },
} as const;
